/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AccountCreationCompletedAliases {
  BUTTON_CLOSE = 'button-close',
  BUTTON_CLOSE_MODAL = 'button-close-modal',
  IMAGE_SUCCESS = 'image-success',
  LAYOUT_ACCOUNT_CREATION_COMPLETED = 'layout-account-creation-completed',
  LAYOUT_ERROR_ACCOUNT_CREATION_COMPLETED = 'layout-error-account-creation-completed',
  PANEL_ERROR_ACCOUNT_CREATION_COMPLETED = 'panel-error-account-creation-completed',
  TEXT_0 = 'text-0',
  TEXT_SUCCCESS_SUBTITLE = 'text-succcess-subtitle',
  TEXT_SUCCESS_TITLE = 'text-success-title',
  TOAST_ACCOUNT_CREATION_ERROR = 'toast-account-creation-error',
}
export { AccountCreationCompletedAliases };
